import React from 'react';
import C18Anchor00 from './C18Anchor00'
import {wsTrans} from '../utils/utils'
import {loadViewPresetsInfo,loadUsersInfo,getUserIndex,getViewPresetIndex,loadPrivsInfo,privs} from './C18utils'
import {cl,globs,constant,dateToDisplayDate, addNumbering} from '../../components/utils/utils';
import LoadingSpinner from './loadingSpinner'

class C18ViewList extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      loaded: false,
      sortMode:4, // last modified
    }
    this.setBreadCrumbs()
    this.loadInfo()
  }
  
  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"View", url:`/usa/c18/reports/viewList`},
            ]},
        },
      )
    }
  }
  
  loadInfo=async()=>{
    await loadUsersInfo()
    await loadViewPresetsInfo()
    await loadPrivsInfo()

//     cl(this.zonesInd)
    this.usersInd={}
    globs.usersInfo.info.forEach(u=>{this.usersInd[u.userId]=u})
    let writePriv=(privs("account",0,constant.AREA_PRIVS_WRITE)!=0)
//     cl(globs.presetsInfo.info)
    this.setState({loaded:true,writePriv:writePriv})
  }
  
  sortViews=(views,sortMode)=>{
    let field=["","name","userId","createdOn","updatedOn"][Math.abs(sortMode)]
    cl(views)
    cl(this.state)
    let dir=(sortMode>0)?1:-1
    views.sort((a,b)=>{
      let af=a[field]
      let bf=b[field]
      switch(field){
        case "name":
          af=af.toLowerCase()
          bf=bf.toLowerCase()
          break
        case "userId":
          af=this.usersInd[af]?.name||"Unknown"
          bf=this.usersInd[bf]?.name||"Unknown"
          break
        case "createdOn":
          bf=af||0
          af=b[field]||0
          break
        case "updatedOn":
          bf=af||0
          af=b[field]||0
          break
        default:
          break
      }
      if(af>bf){return dir}
      if(af<bf){return 0-dir}
      return 0
    })
    return views
  }
  
  onChange=(type,vals)=>{
    cl(type,vals)
    let st=this.state
    switch(type){
      case "deleteView":
        this.deletePreset(vals.presetId)
        cl(vals)
        break
      case "createView":
        vals.e.preventDefault()
        cl("create")
        break
      case 'sort':
//         cl(st)
        if(Math.abs(vals.sortMode)===st.sortMode){
          vals.sortMode=0-st.sortMode
        }
        this.setState(vals)
        break
        
      default:
        break
    }
  }
  
  deletePreset=async(presetId)=>{
    cl(presetId)
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this View?", buttons:["Cancel","Yes"]})
    let ind=getViewPresetIndex(presetId)
    globs.viewPresetsInfo.info.splice(ind,1)
    if(res==="Yes"){
      wsTrans("usa", {cmd: "cRest", uri: "/s/viewPresets", method: "delete", 
        sessionId: globs.userData.session.sessionId, body: {presetId:presetId}})
      this.setState({update:(this.state.update||0)+1})
    }
  }
  
  getPresetLevel=()=>{
    var level="account"
    return level
  }
  
  makeViewList=()=>{
    let pr=globs.viewPresetsInfo?.info
    cl(pr)
    let views = addNumbering(pr, "name")
    views=this.sortViews(views,this.state.sortMode)
    cl(views)
    return views
  }
  
  showViewHead=()=>{
    let sort=this.state.sortMode// 1-5 for the columns
    let icons=[]
    for(let i=0;i<4;i++){
      if(Math.abs(sort)==i+1){
        icons.push((sort<0)?"keyboard_arrow_up":"keyboard_arrow_down")
      } else{
        icons.push("")
      }
    }
//         <th>ID</th>
    return(
      <tr>
        <th><button type="button" aria-label="sort"
          onClick={()=>this.onChange("sort",{sortMode:1})}
        >Name <span className="material-icons-outlined" translate="no">{icons[0]}</span></button></th>
        <th><button type="button" aria-label="sort"
          onClick={()=>this.onChange("sort",{sortMode:2})}
        >Created By <span className="material-icons-outlined" translate="no">{icons[1]}</span></button></th>
        <th><button type="button" aria-label="sort"
          onClick={()=>this.onChange("sort",{sortMode:3})}
        >Created On <span className="material-icons-outlined" translate="no">{icons[2]}</span></button></th>
        <th><button type="button" aria-label="sort"
          onClick={()=>this.onChange("sort",{sortMode:4})}
        >Last Modified <span className="material-icons-outlined" translate="no">{icons[3]}</span></button></th>
        {this.state.writePriv&&
          <>
            <th>Edit</th><th>Delete</th>
          </>
        }
      </tr>
    )
  }
  
  showViewList=()=>{
    cl("showing view list")
    // cl(globs.viewPresetsInfo.info)
    let views=this.makeViewList()
//     cl(views)
//     let i2=1
    let banding=globs.usersInfo?.uiInfo?.tableBanding||true
    let viewRows=views.map((v,i)=>{
      let tableBand=(((i+1)%2)&&banding)?"tableBand":null
      let name=(globs.usersInfo.info[getUserIndex(v.userId)]||{}).name||"Unknown"
      var createDa
      var updateDa
      if(v.createdOn){
        let da=new Date(v.createdOn*1000)
        createDa = dateToDisplayDate(da,"mm/dd/yyyy")
      }else{
        createDa="Unknown"
      }
      if(v.updatedOn){
        let da=new Date(v.updatedOn*1000)
        updateDa = dateToDisplayDate(da,"mm/dd/yyyy")
      }else{
        updateDa="Unknown"
      }
      return(
          <tr key={i} className={tableBand}>
            <td>
            <C18Anchor00 to={`/usa/c18/reports/viewView/${v.presetId}`} className="name" translate="no">{v.name}</C18Anchor00>
            </td>
            <td translate="no">{name}</td>
            <td>{createDa}</td>
            <td>{updateDa}</td>
            {this.state.writePriv&&
              <>
                <td>
                  <C18Anchor00 to={`/usa/c18/reports/editView/${v.presetId}`} className="settings-button material-icons-outlined flip" aria-label="settings" translate="no">
                    build
                  </C18Anchor00>
                </td>

                <td><button type="button" className="material-icons trash" aria-label="delete graph" translate="no"
                  onClick={e=>this.onChange("deleteView",{presetId:v.presetId})}
                >
                  delete_outline
                  </button></td>
              </>
            }
            
          </tr>
        )
    })
    return(viewRows.length > 0 ?
      <div className="table-container">
        <table className="list graphs"><tbody>
          {this.showViewHead()}
          {viewRows}
        </tbody></table>
      </div>
      :
      <div className="none-found">No Views found</div>
    )
  }
  
  render(){
    if(this.state.loaded){
      return(
        <div>
          {this.state.writePriv&&
            <div className="section-controls floatright">
              <C18Anchor00 to={`/usa/c18/reports/editView/`} className="material-icons-outlined add" aria-label="add report" translate="no">
                add
              </C18Anchor00>
            </div>
          }
          <div className="clearfloat"/>
          <div className="clearfloat"></div>
          {this.showViewList()}
        </div>
      )
    }else{
      return <LoadingSpinner message="loading view list..." />
    }
  }
}
      
export default C18ViewList;
